"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryCommand = void 0;
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const index_js_1 = require("../../../entity/actions/format/index.js");
const index_js_2 = require("../../../errors/index.js");
const constants_js_1 = require("../../../table/constants.js");
const decorator_js_1 = require("../../../table/decorator.js");
const index_js_3 = require("../../../table/index.js");
const isString_js_1 = require("../../../utils/validation/isString.js");
const constants_js_2 = require("./constants.js");
const index_js_4 = require("./queryParams/index.js");
class QueryCommand extends index_js_3.TableAction {
    constructor(table, entities = [], query, options = {}) {
        super(table, entities);
        this.params = () => {
            return (0, index_js_4.queryParams)(this.table, ...this[constants_js_1.$sentArgs]());
        };
        this[constants_js_2.$query] = query;
        this[constants_js_2.$options] = options;
    }
    entities(...nextEntities) {
        return new QueryCommand(this.table, nextEntities, this[constants_js_2.$query], this[constants_js_2.$options]);
    }
    query(nextQuery) {
        return new QueryCommand(this.table, this[index_js_3.$entities], nextQuery, this[constants_js_2.$options]);
    }
    options(nextOptions) {
        return new QueryCommand(this.table, this[index_js_3.$entities], this[constants_js_2.$query], nextOptions);
    }
    [constants_js_1.$sentArgs]() {
        if (!this[constants_js_2.$query]) {
            throw new index_js_2.DynamoDBToolboxError('actions.incompleteAction', {
                message: 'QueryCommand incomplete: Missing "query" property'
            });
        }
        return [
            this[index_js_3.$entities],
            this[constants_js_2.$query],
            /**
             * @debt type "Make any QueryOptions<...> instance extend base QueryOptions"
             */
            this[constants_js_2.$options]
        ];
    }
    async send(documentClientOptions) {
        const entityAttrSavedAs = this.table.entityAttributeSavedAs;
        const queryParams = this.params();
        const formattersByName = {};
        this[index_js_3.$entities].forEach(entity => {
            formattersByName[entity.name] = entity.build(index_js_1.EntityFormatter);
        });
        const formattedItems = [];
        let lastEvaluatedKey = undefined;
        let count = 0;
        let scannedCount = 0;
        let consumedCapacity = undefined;
        let responseMetadata = undefined;
        // NOTE: maxPages has been validated by this.params()
        const { attributes, maxPages = 1 } = this[constants_js_2.$options];
        let pageIndex = 0;
        do {
            pageIndex += 1;
            const pageQueryParams = {
                ...queryParams,
                // NOTE: Important NOT to override initial exclusiveStartKey on first page
                ...(lastEvaluatedKey !== undefined ? { ExclusiveStartKey: lastEvaluatedKey } : {})
            };
            const { Items: items = [], LastEvaluatedKey: pageLastEvaluatedKey, Count: pageCount, ScannedCount: pageScannedCount, ConsumedCapacity: pageConsumedCapacity, $metadata: pageMetadata } = await this.table
                .getDocumentClient()
                .send(new lib_dynamodb_1.QueryCommand(pageQueryParams), documentClientOptions);
            for (const item of items) {
                if (this[index_js_3.$entities].length === 0) {
                    formattedItems.push(item);
                    continue;
                }
                const itemEntityName = item[entityAttrSavedAs];
                if (!(0, isString_js_1.isString)(itemEntityName)) {
                    // NOTE: Can only happen if `entityAttrFilter` is false
                    // If data doesn't contain entity name (e.g. migrating to DynamoDB-Toolbox), we try all formatters
                    for (const [entityName, formatter] of Object.entries(formattersByName)) {
                        try {
                            const formattedItem = formatter.format({ ...item, [entityAttrSavedAs]: entityName }, { attributes });
                            formattedItems.push({ ...formattedItem, [constants_js_2.$entity]: entityName });
                            break;
                        }
                        catch {
                            continue;
                        }
                    }
                }
                const formatter = formattersByName[itemEntityName];
                if (formatter === undefined) {
                    continue;
                }
                const formattedItem = formatter.format(item, { attributes });
                formattedItems.push({ ...formattedItem, [constants_js_2.$entity]: itemEntityName });
            }
            lastEvaluatedKey = pageLastEvaluatedKey;
            if (count !== undefined) {
                count = pageCount !== undefined ? count + pageCount : undefined;
            }
            if (scannedCount !== undefined) {
                scannedCount = pageScannedCount !== undefined ? scannedCount + pageScannedCount : undefined;
            }
            consumedCapacity = pageConsumedCapacity;
            responseMetadata = pageMetadata;
        } while (pageIndex < maxPages && lastEvaluatedKey !== undefined);
        return {
            Items: formattedItems,
            ...(lastEvaluatedKey !== undefined ? { LastEvaluatedKey: lastEvaluatedKey } : {}),
            ...(count !== undefined ? { Count: count } : {}),
            ...(scannedCount !== undefined ? { ScannedCount: scannedCount } : {}),
            // return ConsumedCapacity & $metadata only if one page has been fetched
            ...(pageIndex === 1
                ? {
                    ...(consumedCapacity !== undefined ? { ConsumedCapacity: consumedCapacity } : {}),
                    ...(responseMetadata !== undefined ? { $metadata: responseMetadata } : {})
                }
                : {})
        };
    }
}
exports.QueryCommand = QueryCommand;
QueryCommand.actionName = 'query';
__decorate([
    (0, decorator_js_1.sender)()
], QueryCommand.prototype, "send", null);
